import { TTintColor } from '../types/tint-color.type';
import { getRobotintOptions } from './get-robotint-options.helper';
import { robotint } from '../components/robotint';
import { TRobotintConfig } from '../types/robotint-config.type';

type TProps = {
  robotintConfig: TRobotintConfig;
  handleSelectColor: (color: Required<TTintColor>) => void;
};

export const setRobotintOptions = ({ robotintConfig, handleSelectColor }: TProps) => {
  const { clientId, secret, robotintLink } = robotintConfig;

  const robotintOptions = getRobotintOptions({
    clientId,
    secret,
    robotintLink,
    colorSelect: ({ COLOR_NAME, HEX, COLLECTION_NAME }) =>
      handleSelectColor({
        COLOR_NAME,
        HEX,
        COLLECTION_NAME,
      }),
  });

  robotint.setOptions(robotintOptions);
};
